// import React, { useEffect, useMemo, useState } from "react";
// import "./GroupList.css";
// import { Edit, Trash } from "lucide-react";
// import axios from "axios";
// import toast from "react-hot-toast";
// import { useDispatch, useSelector } from "react-redux";

// const GroupList = () => {
//   const [searchQuery, setSearchQuery] = useState("");
//   const [modalOpen, setModalOpen] = useState(false);
//   const [editIndex, setEditIndex] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);

//   const rowsPerPage = 5;
  
//   // const { profile } = useSelector((state) => state.userProfile);
//   // const dispatch = useDispatch();

//   // useEffect(() => {
//   //   dispatch(fetchAdminProfile());
//   // }, [dispatch]);
//   //  console.log("profile data" ,profile);


//   // Dynamic State Data
//   const [groups, setGroups] = useState([
//     { id: 1, group: "Group A", type: "FD", status: "Active" },
//     { id: 2, group: "Group B", type: "RD", status: "Inactive" },
//     { id: 3, group: "Premium FD", type: "FD", status: "Active" },
//   ]);
  



//   const superAdminId = localStorage.getItem("adminuserId")|| 14;

//   const fetchGroups = async () => {
    
//     console.log(superAdminId);
//     try {
//       const res = await axios.get(
//         `https://payyug.in/api/ledger-group/get-all?superAdminId=${superAdminId}`
//       );

//       console.log("response data", res);
//       setGroups(res.data.data || []);
//     } catch (err) {
//       console.error("Fetch Error:", err);
//     }
//   };

//     useEffect(()=> {
//     fetchGroups();
//   },[]);



//   // Form Data
//   const [formData, setFormData] = useState({
//     name:"",
//     type: "",
//     status: "",
//   });

//   // Input Change
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   // Create/Update Submit
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!formData.group || !formData.type || !formData.status) {
//       alert("Please fill all fields");
//       return;
//     }

//     if (editIndex !== null) {
//       const updated = [...groups];
//       updated[editIndex] = { ...updated[editIndex], ...formData };
//       setGroups(updated);
//       setEditIndex(null);
//     } else {
//       setGroups([
//         ...groups,
//         { id: groups.length + 1, ...formData },
//       ]);
//     }

//     setFormData({ name: "", type: "", status: "" });
//     setModalOpen(false);
//   };

//   // Edit Handler
//   // const handleEdit = (index) => {
//   //   setEditIndex(index);
//   //   setFormData(groups[index]);
//   //   setModalOpen(true);
//   // };

//   const handleEdit = (item) => {
//   setEditIndex(item.id);

//   const row = item;
//   setFormData({
//     name: row.name,
//     type: row.type,
//     status: row.status === 1 ? "Active" : "Inactive"
//   });

//   setModalOpen(true);
// };

//   const createUpdate = async (e) => {
//     e.preventDefault();
//     console.log("formdata values are",formData);
//     var payload = {
//       name: formData.name,
//       head_id: 1,
//       superAdminId: superAdminId,
//       createdBy: localStorage.getItem("userid"),
//       staffId: 4,
//       type: formData.type,
//       branchId: 1,
//       status: formData.status === "Active" ? 1 : 0
//     }

//     try {
//       if (editIndex !== null) {
//         // ===================== UPDATE ======================
//         await axios.put(`https://payyug.in/api/ledger-group/update/${editIndex}`, payload);
//         toast.success("Center updated successfully");
//       } else {
//         // ===================== CREATE ======================
//         await axios.post(`https://payyug.in/api/ledger-group/create`, payload);

//         toast.success("Center created successfully");
//       }

//       fetchGroups();
//       setModalOpen(false);
//     } catch (error) {
//       console.log("API Error:", error);
//       toast.error(error?.response?.data?.error || "Failed to save");
//     }
//   };

//    const handledelete = (id) => async () => {
//       const confirmDelete = window.confirm("Are you sure you want to delete this center?");
//       if (!confirmDelete) return;

//       try {
//         await axios.delete(`https://payyug.in/api//ledger-group/delete/${id}`);
//         toast.success("Center deleted successfully");
//         fetchGroups();
//       } catch (error) {
//         toast.error("Failed to delete center");
//       }
//     };

//   // Search + Pagination
//   const filteredData = useMemo(() => {
//     let data = [...groups];

//     if (searchQuery.trim()) {
//       data = data.filter((item) =>
//         Object.values(item)
//           .join(" ")
//           .toLowerCase()
//           .includes(searchQuery.toLowerCase())
//       );
//     }

//     // if (searchQuery.trim()) {
//     //   data = data.filter((item) =>
//     // item.group.toLowerCase().includes(searchQuery.toLowerCase()) ||
//     // item.type.toLowerCase().includes(searchQuery.toLowerCase()) ||
//     // item.status.toLowerCase().includes(searchQuery.toLowerCase())
//     //   );
//     // }

//     return data;
//   }, [groups, searchQuery]);

//   const totalPages = Math.ceil(filteredData.length / rowsPerPage);
//   const paginatedData = filteredData.slice(
//     (currentPage - 1) * rowsPerPage,
//     currentPage * rowsPerPage
//   );

//   return (
//     <>
//       <div className="account-group-list-container">
//         <h2 className="heading">Group List</h2>

//         <div className="account-group-list-top-section">
//           <input
//             type="text"
//             placeholder="Search by Group / Type / Status..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />

//           <button
//             className="add-btn"
//             onClick={() => {
//               setFormData({ group: "", type: "", status: "" });
//               setEditIndex(null);
//               setModalOpen(true);
//             }}
//           >
//             Add New
//           </button>
//         </div>

//         {/* Table */}
//         <div className="account-group-list-report-section">
//           <table className="account-group-list-report-table">
//             <thead>
//               <tr>
//                 <th>SN</th>
//                 <th>Group Name</th>
//                 <th>Type</th>
//                 <th>Status</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {paginatedData.length > 0 ? (
//                 paginatedData.map((item, index) => (
//                   <tr key={item.id}>
//                     <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//                     <td>{item.name}</td>
//                     <td>{item.type}</td>
//                     <td>{item.status === 1 ? "Active" : "Inactive"}</td>
//                     <td className="group-list-action-buttons">
//                       <button
//                       className="edit-icon-gl"
//                         onClick={() =>
//                           handleEdit(item)
//                         }
//                       >
//                         <Edit size={18} />
//                       </button>
//                       <Trash className="delete-icon-gl" onClick={handledelete(item.id)}> </Trash>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="5" style={{ textAlign: "center" }}>
//                     No results found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//          {/* Pagination */}
//          <div className="account-group-list-pagination-section">
//           {filteredData.length > rowsPerPage && (
//             <div className="account-group-list-pagination-div">
//               <button
//                 onClick={() => setCurrentPage(currentPage - 1)}
//                 disabled={currentPage === 1}
//               >
//                 ⬅ Prev
//               </button>

//               <span>
//                 Page {currentPage} of {totalPages}
//               </span>

//               <button
//                 onClick={() => setCurrentPage(currentPage + 1)}
//                 disabled={currentPage === totalPages}
//               >
//                 Next ➡
//               </button>
//             </div>
//           )}
//          </div>
          

//         {/* Modal */}
//         {modalOpen && (
//           <div className="dialog-overlay">
//             <div className="dialog-box">
//               <h2 className="dialog-box-heading">
//                 {editIndex !== null ? "Edit Group" : "Add New Group"}
//               </h2>

//               <form className="dialog-box-form-section" onSubmit={createUpdate}>
//                 <div className="dialog-box-input-group">
//                   <label>Name</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="dialog-box-input-group">
//                   <label>Status</label>
//                   <select name="status" value={formData.status} onChange={handleChange}>
//                     <option value="">Select Status</option>
//                     <option value="Active">Active</option>
//                     <option value="Inactive">Inactive</option>
//                   </select>
//                 </div>

//                 <div className="dialog-box-input-group">
//                   <label>Type</label>
//                   <select name="type" value={formData.type} onChange={handleChange}>
//                     <option value="">Select Type</option>
//                     <option value="CR">CR</option>
//                     <option value="DR">DR</option>
//                     {/* <option value=""></option> */}
//                   </select>
//                 </div>

//                 <div className="dialog-btns">
//                   <button type="submit">
//                     {editIndex !== null ? "Update" : "Create"}
//                   </button>

//                   <button type="button" onClick={() => setModalOpen(false)}>
//                     Cancel
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default GroupList;




import React, { useEffect, useState, useMemo, useCallback } from "react";
import "./GroupList.css";
import { Edit, Trash, FileSpreadsheet, FileText } from "lucide-react";
import axios from "axios";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { toast } from "react-toastify";

/**
 * @param {string} imageUrl - The URL of the image to fetch.
 * @returns {Promise<string|null>} Resolves with Base64 data string or null if failed.
 */
const BASE_URL = "https://payyug.in/api";

const getBase64ImageFromUrl = async (imageUrl) => {
  if (!imageUrl) return null;

  try {
    const response = await fetch(imageUrl, { mode: "cors" });
    if (!response.ok) {
      throw new Error(`Failed to fetch image: ${response.statusText}`);
    }
    
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("getBase64ImageFromUrl Error:", error);
    return null;
  }
};

const GroupList = () => {
  const [groups, setGroups] = useState([]);
  const [branches, setBranches] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [company, setCompany] = useState(null);

  // Pagination State
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  // Form & Modals State
  const [modalOpen, setModalOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  // Delete Confirmation Modal State
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  const superAdminId = useMemo(
    () => localStorage.getItem("adminuserId") || 14,
    []
  );

  // Form State
  const [formData, setFormData] = useState({
    name: "",
    type: "",
    status: "",
    branchId: "",
  });

  /* ================= FETCH COMPANY DETAILS ================= */
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/get-company?superAdminId=${superAdminId}`
        );
        const data = await response.json();

        if (response.ok && data) {
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          setCompany(data);
        }
      } catch (err) {
        console.error("Error fetching company details:", err);
      }
    };

    if (superAdminId) fetchCompany();
  }, [superAdminId]);

  /* ================= FETCH BRANCHES ================= */
  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/get-branch`, {
          params: { SuperAdminId: superAdminId, limit: "all" },
        });
        setBranches(res?.data?.branches || []);
      } catch (err) {
        console.error("Fetch Branch Error:", err);
      }
    };
    fetchBranches();
  }, [superAdminId]);

  /* ================= FETCH GROUPS ================= */
  const fetchGroups = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/ledger-group/get-all?superAdminId=${superAdminId}`
      );
      setGroups(res.data.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
      toast.error("Failed to fetch groups");
    } finally {
      setLoading(false);
    }
  }, [superAdminId]);

  useEffect(() => {
    fetchGroups();
  }, [fetchGroups]);

  /* ================= FORM HANDLERS ================= */
  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleOpenAddModal = () => {
    setFormData({ name: "", type: "", status: "", branchId: "" });
    setEditIndex(null);
    setModalOpen(true);
  };

  const handleEdit = (item) => {
    setEditIndex(item.id);
    setFormData({
      name: item.name || "",
      type: item.type || "",
      status: item.status === 1 ? "Active" : "Inactive",
      branchId: item.branchId || "",
    });
    setModalOpen(true);
  };

  const createUpdate = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.type || !formData.status || !formData.branchId) {
      toast.error("Please fill all required fields");
      return;
    }

    const payload = {
      name: formData.name,
      head_id: 1,
      superAdminId: Number(superAdminId),
      createdBy: Number(superAdminId),
      staffId: 4,
      type: formData.type,
      branchId: Number(formData.branchId),
      status: formData.status === "Active" ? 1 : 0,
    };

    try {
      if (editIndex !== null) {
        // UPDATE
        const res = await axios.put(
          `${BASE_URL}/ledger-group/update/${editIndex}`,
          payload
        );
        toast.success(res?.data?.message || "Group updated successfully");
      } else {
        // CREATE
        const res = await axios.post(`${BASE_URL}/ledger-group/create`, payload);
        toast.success(res?.data?.message || "Group created successfully");
      }

      fetchGroups();
      setModalOpen(false);
    } catch (error) {
      console.error("API Error:", error);
      toast.error(error?.response?.data?.error || "Failed to save group");
    }
  };

  /* ================= DELETE HANDLERS ================= */
  const openDeleteModal = (id) => {
    setSelectedDeleteId(id);
    setDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    if (!selectedDeleteId) return;

    try {
      const res = await axios.delete(
        `${BASE_URL}/ledger-group/delete/${selectedDeleteId}`
      );
      toast.success(res?.data?.message || "Group deleted successfully");
      fetchGroups();
    } catch (error) {
      console.error("Delete Error:", error);
      toast.error(error?.response?.data?.message || "Failed to delete group");
    } finally {
      setDeleteModalOpen(false);
      setSelectedDeleteId(null);
    }
  };

  /* ================= SEARCH & FILTERING ================= */
  const filteredData = useMemo(() => {
    let data = [...groups];

    if (searchQuery.trim()) {
      data = data.filter((item) => {
        const nameMatch = item.name?.toLowerCase().includes(searchQuery.toLowerCase());
        const typeMatch = item.type?.toLowerCase().includes(searchQuery.toLowerCase());
        const statusMatch = (item.status === 1 ? "active" : "inactive").includes(
          searchQuery.toLowerCase()
        );
        return nameMatch || typeMatch || statusMatch;
      });
    }

    return data;
  }, [groups, searchQuery]);

  /* ================= PAGINATION COMPUTATIONS ================= */
  const isShowAll = rowsPerPage === "ALL";
  const totalEntries = filteredData.length;
  const effectiveRowsPerPage = isShowAll ? totalEntries : Number(rowsPerPage);
  const totalPages =
    isShowAll || totalEntries === 0
      ? 1
      : Math.ceil(totalEntries / effectiveRowsPerPage);

  const startIndex = isShowAll ? 0 : (currentPage - 1) * effectiveRowsPerPage;
  const endIndex = isShowAll
    ? totalEntries
    : Math.min(startIndex + effectiveRowsPerPage, totalEntries);

  const paginatedData = isShowAll
    ? filteredData
    : filteredData.slice(startIndex, endIndex);

  /* ================= EXPORT TO EXCEL ================= */
  const exportToExcel = () => {
    if (filteredData.length === 0) {
      toast.error("No data available to export");
      return;
    }

    const exportList = filteredData.map((item, index) => ({
      SN: index + 1,
      "Group Name": item.name || "N/A",
      Type: item.type || "N/A",
      "Branch ID": item.branchId || "N/A",
      Status: item.status === 1 ? "Active" : "Inactive",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportList);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Ledger Groups");
    XLSX.writeFile(workbook, "Ledger_Groups_Report.xlsx");
  };

/* ================= EXPORT TO PDF ================= */
const exportToPDF = async () => {
  if (!filteredData || filteredData.length === 0) {
    toast.error("No data available to export");
    return;
  }

  const doc = new jsPDF({
  orientation: "p",
  unit: "mm",
  format: "a4",
  compress: true,
});
  const pageWidth = doc.internal.pageSize.width;

  // ================= LOGO SECTION (SQUARE, NO BORDER) =================
  const logoX = 15;
  const logoY = 12;
  const logoSize = 22;

  // Fetch & Draw Logo Safely
  if (company?.logoUrl) {
    const base64Logo = await getBase64ImageFromUrl(company.logoUrl);

    if (base64Logo) {
      try {
        const isJpeg =
          company.logoUrl.toLowerCase().includes(".jpg") ||
          company.logoUrl.toLowerCase().includes(".jpeg");
        const format = isJpeg ? "JPEG" : "PNG";

        // Render clean square image directly without clipping or circular borders
        doc.addImage(
          base64Logo,
          format,
          logoX,
          logoY,
          logoSize,
          logoSize
        );
      } catch (err) {
        console.warn("Logo draw error:", err);
      }
    }
  }

  // ================= COMPANY DETAILS =================
  const nameX = logoX + logoSize + 8;
  const nameY = 16;
  const nameMaxWidth = pageWidth - nameX - 15;

  // Company Name
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.setTextColor(2, 44, 58); // #022c3a

  const companyNameText = doc.splitTextToSize(
    (company?.name || "COMPANY NAME").toUpperCase(),
    nameMaxWidth
  );
  doc.text(companyNameText, nameX, nameY);

  let currentY = nameY + companyNameText.length * 5;

  // Address, Email, Contact
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(80, 80, 80);

  const addressText = doc.splitTextToSize(
    company?.address || "Company Address",
    nameMaxWidth
  );
  doc.text(addressText, nameX, currentY);
  currentY += addressText.length * 4;

  doc.text(`Email: ${company?.email || "-"}`, nameX, currentY);
  currentY += 4;

  doc.text(`Phone: ${company?.contact || "-"}`, nameX, currentY);
  
  // INCREASED GAP BEFORE DIVIDER LINE
  currentY += 10; 

  // Divider Line
  doc.setDrawColor(220, 220, 220);
  doc.setLineWidth(0.3);
  doc.line(10, currentY, pageWidth - 10, currentY);

  // ================= REPORT TITLE =================
  currentY += 8;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);
  doc.text("Ledger Groups Report", pageWidth / 2, currentY, {
    align: "center",
  });

  // ================= TABLE DATA =================
  const tableColumn = ["SN", "Group Name", "Type", "Branch ID", "Status"];
  const tableRows = filteredData.map((item, index) => [
    index + 1,
    item.name || "N/A",
    item.type || "N/A",
    item.branchId || "N/A",
    item.status === 1 ? "Active" : "Inactive",
  ]);

  autoTable(doc, {
    startY: currentY + 6,
    head: [tableColumn],
    body: tableRows,
    theme: "grid",
    styles: {
      fontSize: 8,
      cellPadding: 3,
      halign: "center",
      valign: "middle",
      textColor: [50, 50, 50],
    },
    headStyles: {
      fillColor: [2, 44, 58], // Dark Navy #022c3a
      textColor: [255, 255, 255],
      fontStyle: "bold",
      fontSize: 8.5,
      halign: "center",
    },
    alternateRowStyles: {
      fillColor: [248, 250, 252],
    },
    margin: { left: 10, right: 10, top: 10, bottom: 15 },

    // Page Border and Footer
    didDrawPage: function (data) {
      const pWidth = doc.internal.pageSize.width;
      const pHeight = doc.internal.pageSize.height;

      // Page Border
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.2);
      doc.rect(8, 8, pWidth - 16, pHeight - 16);

      // Footer Page Numbering
      doc.setFontSize(8);
      doc.setTextColor(120, 120, 120);
      doc.text(
        `Page ${data.pageNumber} of ${doc.internal.getNumberOfPages()}`,
        pWidth / 2,
        pHeight - 11,
        { align: "center" }
      );
    },
  });

  doc.save("Ledger_Groups_Report.pdf");
};

  return (
    <div className="account-group-list-container">
      <h2 className="heading">Group List</h2>

      {/* Top Controls Bar */}
      <div className="account-group-list-top-section">
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <span>Show</span>
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(
                e.target.value === "ALL" ? "ALL" : Number(e.target.value)
              );
              setCurrentPage(1);
            }}
            className="bw-entries-select"
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value="ALL">All</option>
          </select>
          <span>entries</span>
        </div>

        <input
          type="text"
          placeholder="Search by Group / Type / Status..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />

        <div style={{ display: "flex", gap: "10px" }}>
          <button
            type="button"
            className="add-btn"
            style={{ backgroundColor: "#217346" }}
            onClick={exportToExcel}
            title="Export to Excel"
          >
            <FileSpreadsheet size={18} style={{ marginRight: "4px" }} /> Excel
          </button>

          <button
            type="button"
            className="add-btn"
            style={{ backgroundColor: "#b30b00" }}
            onClick={exportToPDF}
            title="Export to PDF"
          >
            <FileText size={18} style={{ marginRight: "4px" }} /> PDF
          </button>

          <button className="add-btn" onClick={handleOpenAddModal}>
            Add New
          </button>
        </div>
      </div>

      {/* Report Table */}
      <div className="account-group-list-report-section">
        <table className="account-group-list-report-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Group Name</th>
              <th>Type</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" style={{ textAlign: "center", padding: "16px" }}>
                  Loading Data...
                </td>
              </tr>
            ) : paginatedData.length > 0 ? (
              paginatedData.map((item, index) => (
                <tr key={item.id || index}>
                  <td>{startIndex + index + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.type}</td>
                  <td>{item.status === 1 ? "Active" : "Inactive"}</td>
                  <td className="group-list-action-buttons">
                    <button
                      className="edit-icon-gl"
                      onClick={() => handleEdit(item)}
                      title="Edit"
                    >
                      <Edit size={18} />
                    </button>
                    <button
                      className="delete-icon-gl"
                      onClick={() => openDeleteModal(item.id)}
                      title="Delete"
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      <Trash size={18} />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: "center", padding: "16px" }}>
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Bar */}
      {totalEntries > 0 && (
        <div className="account-group-list-pagination-section">
          <span>
            Showing {startIndex + 1} to {endIndex} of {totalEntries} entries
          </span>

          {!isShowAll && totalPages > 1 && (
            <div className="account-group-list-pagination-div">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                ⬅ Prev
              </button>

              <span>
                Page {currentPage} of {totalPages}
              </span>

              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next ➡
              </button>
            </div>
          )}
        </div>
      )}

      {/* Add/Edit Modal */}
      {modalOpen && (
        <div className="dialog-overlay">
          <div className="dialog-box">
            <h2 className="dialog-box-heading">
              {editIndex !== null ? "Edit Group" : "Add New Group"}
            </h2>

            <form className="dialog-box-form-section" onSubmit={createUpdate}>
              {/* Select Branch */}
              <div className="dialog-box-input-group">
                <label>Select Branch</label>
                <select
                  name="branchId"
                  value={formData.branchId}
                  onChange={handleChange}
                  required
                >
                  <option value="">-- Select Branch --</option>
                  {branches.map((b) => (
                    <option key={b.id || b._id} value={b.id || b._id}>
                      {b.name || b.branchName || `Branch ID: ${b.id || b._id}`}
                    </option>
                  ))}
                </select>
              </div>

              {/* Name */}
              <div className="dialog-box-input-group">
                <label>Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter Group Name"
                  required
                />
              </div>

              {/* Type */}
              <div className="dialog-box-input-group">
                <label>Type</label>
                <select
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Type</option>
                  <option value="CR">CR</option>
                  <option value="DR">DR</option>
                </select>
              </div>

              {/* Status */}
              <div className="dialog-box-input-group">
                <label>Status</label>
                <select
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Status</option>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>

              <div className="dialog-btns">
                <button type="submit">
                  {editIndex !== null ? "Update" : "Create"}
                </button>

                <button type="button" onClick={() => setModalOpen(false)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {deleteModalOpen && (
        <div className="dialog-overlay">
          <div className="dialog-box" style={{ maxWidth: "400px" }}>
            <h2 className="dialog-box-heading">Confirm Delete</h2>
            <p style={{ margin: "15px 0", color: "#555" }}>
              Are you sure you want to delete this group? This action cannot be
              undone.
            </p>
            <div className="dialog-btns">
              <button
                type="button"
                onClick={confirmDelete}
                style={{ backgroundColor: "#d32f2f" }}
              >
                Delete
              </button>
              <button type="button" onClick={() => setDeleteModalOpen(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GroupList;